<template>
  <div>
    <navbar></navbar>
    <div class="row ml-0 mr-0" style="box-shadow: none; margin-top: 95px">
      <div class="col-3 pl-0 pr-0"></div>
      <div class="col-6 pl-0 pr-0">
        <div class="createWorkspaceTitle" style="margin-bottom: 30px">
          Edit Workspace
        </div>
        <LpCreateWorkspace
          :workspace="$route.params.workspace"
        ></LpCreateWorkspace>
      </div>
      <div class="col-3 pl-0 pr-0"></div>
    </div>
  </div>
</template>
<script>
import NavbarNew from "../Layout/NavbarNew";
import LpCreateWorkspace from "./LpCreateWorkspace";
import { mapGetters } from "vuex";
export default {
  components: {
    [NavbarNew.name]: NavbarNew,
    LpCreateWorkspace,
  },
  destroyed() {
    document.body.className = "pageMainScroll sidebar-mini";
  },
};
</script>
<style>
</style>